module.exports = __webpack_public_path__ + "media/marker/map-pin-active-ea1152d8.png";